import React from "react";
import { COMPANY_ID, TOKEN_SLUG } from "../../utils/constants";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { contact } from "../../Services/Contact.service";
import { toast } from "react-hot-toast";
import SEO from "../SEO/SEO.jsx"

const Contact = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
      contact: "",
      send: "Send Message",
    },

    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required("Name is required field")
        .matches(/^[a-zA-Z ]*$/, "Name should be string"),
      email: Yup.string()
        .required("Email is required field")
        .email()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Email is not valid"
        ),
      contact: Yup.string()
        .required("Phone is required field")
        .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number."),
      subject: Yup.string().required("Subject is required field"),
      message: Yup.string().required("Message is required field"),
    }),

    onSubmit: (value, { resetForm, setSubmitting }) => {
      value = { ...value, company_id: COMPANY_ID };
      setSubmitting(true);
      contact(value)
        .then((res) => {
          toast.success("Thanks, Will update you soon");

          resetForm();
          setSubmitting(false);

          if (res.data.token) localStorage.setItem(TOKEN_SLUG, res.data.token);
        })
        .catch((err) => {
          console.error("error in contactus ", err);
          setSubmitting(false);
        });
    },
  });

  return (
    <div className="middle contact-page">
      {/* Adding SEO Meta tags */}
      <SEO
        title={"Contact WashWoosh | Book Your Car Wash in Jaipur Today"}
        description={
          "Need a car wash in Jaipur? Contact WashWoosh for fast, professional doorstep car cleaning. Call or book via our app – We're ready to help!"
        }
        canonical={"https://washwoosh.com/contact"}
      />
      <div className="contact-men">
        <div className="container">
          <div className="heading-men">
            <h1>Contact WashWoosh</h1>
            <p>
              Our dedicated support team is here to assist you with any queries or needs. Feel free to reach out!
            </p>
          </div>
          <div className="row mt-4 align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="contact-left" id="book-now">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.submitForm();
                  }}
                >
                  <div className="row mt-3">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-text">
                        <label>Your Name*</label>
                        <input
                          className="input-btn"
                          type="text"
                          name="Name"
                          placeholder="First Name"
                          value={formik.values.name}
                          onChange={(e) =>
                            formik.setFieldValue("name", e.target.value)
                          }
                        />
                        <div className="error-css">
                          {formik.touched.name && formik.errors.name}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-text">
                        <label>Your Email*</label>
                        <input
                          className="input-btn"
                          type="text"
                          name="Name"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={(e) =>
                            formik.setFieldValue("email", e.target.value)
                          }
                        />
                        <div className="error-css">
                          {formik.touched.email && formik.errors.email}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-text">
                        <label>Your Contact Number*</label>
                        <input
                          className="input-btn"
                          type="text"
                          name="Name"
                          placeholder="Number"
                          value={formik.values.contact}
                          onChange={(e) =>
                            formik.setFieldValue("contact", e.target.value)
                          }
                        />
                        <div className="error-css">
                          {formik.touched.contact && formik.errors.contact}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-text">
                        <label>Subject*</label>
                        <input
                          className="input-btn"
                          type="text"
                          name="Name"
                          placeholder="Subject"
                          value={formik.values.subject}
                          onChange={(e) =>
                            formik.setFieldValue("subject", e.target.value)
                          }
                        />
                        <div className="error-css">
                          {formik.touched.subject && formik.errors.subject}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-text">
                        <label>Your Message*</label>
                        <input
                          className="input-btn input-btn1"
                          type="text"
                          name="Name"
                          placeholder="Message...."
                          value={formik.values.message}
                          onChange={(e) =>
                            formik.setFieldValue("message", e.target.value)
                          }
                        />
                        <div className="error-css">
                          {formik.touched.message && formik.errors.message}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="book-mafia mt-2">
                        <button
                          className="btn head-btn head-btn1"
                          type="submit"
                          disabled={formik.isSubmitting}
                        >
                          <span>
                            {formik.isSubmitting
                              ? "Loading..."
                              : "Send Message ⇾"}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="contact-right">
                <div class="heading-men"><h2 className="text-left">Get in Touch with Our Team</h2></div>
                <div className="working-hours-text">
                  <h2>Working Hours</h2>
                  <p>Monday to Saturday: 9 am to 10 pm</p>
                  <p>
                    <b>
                      Note that we also provide corporate deals and event
                      solutions.
                    </b>
                  </p>
                  <p>Write to us!</p>
                </div>
                <div className="working-hours-one">
                  <a
                    href="tel:1800-2700-722" className="contact-links"
                    aria-label="Call Company Name at 1800-2700-722"
                  >
                    <i className="fa-solid fa-phone" />
                    <h2>1800-2700-722</h2>
                  </a>
                </div>
                <div className="working-hours-one">
                  <a href="mailto:info@washwoosh.com" className="contact-links"
                    aria-label="Send an email to WashWoosh at info@washwoosh.com">
                    <i className="fa-solid fa-envelope" />
                    <h2>info@washwoosh.com</h2>
                  </a>

                </div>
                <div className="working-hours-one locationicon">
                  <i className="fa-solid fa-location-dot" />
                  <h2>
                    <b>Corporate Office:</b> Yogi tower, C-17, Mahalaxmi Nagar
                    Rd, behind world trade park mall, D-Block, Malviya Nagar,
                    Jaipur - 302017, Rajasthan
                  </h2>
                </div>

                <div className="working-hours-one locationicon">
                  <i className="fa-solid fa-location-dot" />
                  <h2>
                    <b>Registered Address:</b> 70 Mahesh Nagar EXT-B, Bank
                    Colony, Lal Kothi, GandhiNagar, Jaipur - 302015, Rajasthan
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div class="heading-men contact-botton-head mt-4 pb-0"><h2>Book Your Doorstep Car Wash Today</h2></div>
        </div>
        <div className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14238.589731277323!2d75.7962710277492!3d26.85116396378367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5003209e2e5%3A0xba081af6409e1d54!2sWashWoosh%20-%20A%20Unit%20of%20SatelliteKey%20IT%20Solutions%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1747896011162!5m2!1sen!2sin"
            width="100%"
            height={350}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
